module.exports = __webpack_public_path__ + "img/LOG.00ea42bf.png";